export default __webpack_public_path__ + "static/media/global-footprint-Header-Tablet.9ca45a40.jpg";